import React, { useEffect } from 'react';

const LegalMentions = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div className="max-w-4xl mx-auto px-4 py-8">
      <h1 className="text-3xl font-bold text-green-800 mb-6">Mentions légales</h1>
      
      <section className="mb-8">
        <h2 className="text-xl font-semibold text-orange-500 mb-3">Éditeur du site</h2>
        <p className="mb-1">Consulat Général de Côte d&apos;Ivoire à Paris</p>
        <p className="mb-1">Adresse : 19 rue de la pépinière, 75008 Paris</p>
        <p className="mb-1">Téléphone : +33 1 81 72 66 04</p>
        <p className="mb-1">Email : consulat.france@diplomatie.gouv.ci</p>
        <p className="mb-1">Directeur de la publication : Sory DIAKITÉ</p>
      </section>
      
      <section className="mb-8">
        <h2 className="text-xl font-semibold text-orange-500 mb-3">Hébergement</h2>
        <p className="mb-1">Le site est hébergé par :</p>
        <p className="mb-1">SCALEWAY</p>
        <p className="mb-1">Société par Actions Simplifiée au capital de 214 410,50 Euros</p>
        <p className="mb-1">SIREN : 433 115 904 RCS Paris</p>
        <p className="mb-1">Siège social : 8 rue de la Ville l&apos;Evêque, 75008 Paris</p>
      </section>
      
      <section className="mb-8">
        <h2 className="text-xl font-semibold text-orange-500 mb-3">Développement du site</h2>
        <p className="mb-1">Ce site a été conçu et développé par :</p>
        <p className="mb-1">Monsieur YAPO</p>
        <p className="mb-1">Consultant en Technologies Numériques</p>
        <p className="mb-1">Email : contact@monsieur-yapo.com</p>
        <p className="mb-1">Site web : <a href="https://monsieur-yapo.com" target="_blank" rel="noopener noreferrer">https://monsieur-yapo.com</a></p>
      </section>
      
      <section className="mb-8">
        <h2 className="text-xl font-semibold text-orange-500 mb-3">Propriété intellectuelle</h2>
        <p className="mb-4">
          L&apos;ensemble des contenus présents sur ce site (textes, images, logos, documents téléchargeables, etc.) 
          sont protégés par le droit d&apos;auteur et sont la propriété exclusive du Consulat Général de Côte d&apos;Ivoire 
          à Paris ou de tiers ayant autorisé leur utilisation.
        </p>
        <p>
          Toute reproduction ou représentation, totale ou partielle, est interdite sans autorisation écrite préalable.
        </p>
      </section>
      
      <section className="mb-8">
        <h2 className="text-xl font-semibold text-orange-500 mb-3">Responsabilité</h2>
        <p className="mb-4">
          Les informations fournies sur ce site sont données à titre indicatif et sont régulièrement mises à jour. 
          Toutefois, le Consulat Général de Côte d&apos;Ivoire à Paris ne saurait être tenu responsable des erreurs ou omissions.
        </p>
        <p>
          L&apos;utilisateur est seul responsable de l&apos;exactitude des données qu&apos;il renseigne, notamment son adresse postale.
        </p>
      </section>
    </div>
  );
};

export default LegalMentions;
